// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"167":"6fdd5616","187":"d8b442a5","524":"f4b8b6eb","620":"e133c371","899":"d5af43c7"}[chunkId] + ".chunk.css";
};